import React from 'react';
import { Box, Chip, Tooltip, Typography } from '@material-ui/core';

export const THRESHOLD_CHIP_STYLE = {
    height: 26,
    fontSize: 12,
    fontWeight: 500,
    backgroundColor: '#F4F4F6',
    border: '1px solid #E0E0E6',
    maxWidth: '100%',
};

const ThresholdChipsSummary = ({ items, compact = false, tableView = false }) => {
    if (!items?.length) {
        return (
            <Typography variant="body2" color="textSecondary">
                —
            </Typography>
        );
    }

    const fullSummary = items.map((item) => item.chipLabel).join(' · ');
    const visibleItems = compact && items.length > 2 ? items.slice(0, 2) : items;
    const hiddenCount = items.length - visibleItems.length;
    const maxWidth = tableView ? 360 : compact ? '100%' : 420;

    return (
        <Tooltip title={fullSummary} placement="top" arrow disableHoverListener={!compact}>
            <Box display="flex" flexWrap="wrap" style={{ gap: 6, maxWidth }}>
                {visibleItems.map((item) => (
                    <Chip
                        key={item.key}
                        size="small"
                        label={item.chipLabel}
                        style={THRESHOLD_CHIP_STYLE}
                    />
                ))}
                {hiddenCount > 0 && (
                    <Chip
                        size="small"
                        label={`+${hiddenCount} nivel${hiddenCount > 1 ? 'es' : ''}`}
                        style={{ ...THRESHOLD_CHIP_STYLE, fontWeight: 600 }}
                    />
                )}
            </Box>
        </Tooltip>
    );
};

export default ThresholdChipsSummary;
